// extracted by mini-css-extract-plugin
export default {"navbar":"SubNavbar_navbar__FCG1i"};